/**
 * Limite do título em botões de resposta rápida no WhatsApp (Meta Cloud API).
 * Deve coincidir com WHATSAPP_REPLY_BUTTON_TITLE_MAX na API (uraButtons.js).
 */
export const WHATSAPP_REPLY_BUTTON_TITLE_MAX = 20;

/**
 * @param {string[]} botoes
 * @returns {string|null} mensagem de erro ou null
 */
export function validateChatbotButtonLabels(botoes) {
  const arr = Array.isArray(botoes) ? botoes : [];
  const max = WHATSAPP_REPLY_BUTTON_TITLE_MAX;
  for (let i = 0; i < arr.length; i += 1) {
    const t = String(arr[i] ?? "").trim();
    if (!t) continue;
    if (t.length > max) {
      return `Botão ${i + 1}: máximo ${max} caracteres (WhatsApp).`;
    }
  }
  return null;
}
